import * as z from "zod/v4";
import { ExternalShipmentTracker } from "./trackable";

// TODO(paul): remove casts
const AddressSchema_ = z.object({
  company: z.string().nullish(),
  name: z.string().nullish(),
  phone: z.string().nullish(),
  email: z.string().nullish(),
  street1: z.string().nullish(),
  street2: z.string().nullish(),
  city: z.string().nullish(),
  state: z.string().nullish(),
  zip: z
    .string()
    .nullish()
    .transform((val) => val ?? ""), // Should probably just be nullish(), but too many type errors to fix right now
  country: z.string().nullish() as unknown as z.ZodString,
  residential: z.boolean().nullish(),
});
export const AddressSchema: z.ZodType<Address> = AddressSchema_;
export interface Address extends z.infer<typeof AddressSchema_> {}

const ShipmentParcelZodSchema_ = z.object({
  length: z.number().nullish(),
  width: z.number().nullish(),
  height: z.number().nullish(),
  weight: z.number(),
});
export const ShipmentParcelZodSchema: z.ZodType<ShipmentParcel> =
  ShipmentParcelZodSchema_;
export interface ShipmentParcel
  extends z.infer<typeof ShipmentParcelZodSchema_> {}

// TODO(paul): remove casts
const FormSchema_ = z.object({
  id: z.string().nullish() as unknown as z.ZodString,
  form_type: z.string().nullish() as unknown as z.ZodString,
  form_url: z.string().url().nullish() as unknown as z.ZodString,
  submitted_electronically: z.boolean().nullish() as unknown as z.ZodBoolean,
});
const FormSchema: z.ZodType<Form> = FormSchema_;
export interface Form extends z.infer<typeof FormSchema_> {}

export enum ShippingProviderType {
  CANADA_POST = "canada_post",
  EASYPOST = "easypost",
  GLOBALE = "globale",
  IDF_SHIPPING = "idf_shipping",
  MOCK = "mock",
  NZ_POST = "nz_post",
  SEKO = "seko",
  SENDCLOUD = "sendcloud",
  SENDCLOUD_EU = "sendcloud_eu",
  SOAPBOX = "soapbox",
  UPS_DIRECT_CA = "ups_direct_ca",
  UPS_DIRECT_US = "ups_direct_us",
  WEGROW = "wegrow",
}

// TODO(paul): remove casts
export const RateSchema_ = z.object({
  id: z.string(),
  shipment_id: z.string(),
  rate: z.union([z.number(), z.string()]).nullish() as unknown as z.ZodString,
  currency: z
    .union([z.number(), z.string()])
    .nullish() as unknown as z.ZodString,
  carrier: z.string(),
  service: z.string(),
  delivery_date: z.string().nullish(),
  delivery_days: z.number().nullish(),
  delivery_date_guaranteed: z.boolean().nullish(),
  upcharge: z.string().optional(),
  created_at: z.string(),
  updated_at: z.string(),
  shipping_provider_type: z
    .enum(ShippingProviderType)
    .default(ShippingProviderType.EASYPOST),
  carrier_account_id: z.string().nullish() as unknown as z.ZodString,
  is_from_alternative_account: z.boolean().nullish(),
  is_merchant_carrier_account: z.boolean().nullish(),
  isReturn: z.boolean().optional(),
  options: z
    .object({ labelAvailable: z.boolean(), qrCodeAvailable: z.boolean() })
    .optional(),
});

const RateSchema: z.ZodType<Rate> = RateSchema_;
export interface Rate extends z.infer<typeof RateSchema_> {}

const LabelSchema_ = z.object({
  id: z.string(),
  label_url: z.union([z.string(), z.string().url(), z.null()]),
  label_date: z.any().optional() as unknown as z.ZodString,
});
const LabelSchema: z.ZodType<Label> = LabelSchema_;
export interface Label extends z.infer<typeof LabelSchema_> {}

export interface AddressVerification {
  verifications: {
    delivery: { success: boolean; errors: { message: string }[] };
  };
}

const ShipmentSchema_ = z.object({
  id: z.string(),
  to_address: AddressSchema.nullish(),
  from_address: AddressSchema.nullish(),
  status: z.string().nullish() as unknown as z.ZodString,
  parcel: ShipmentParcelZodSchema.nullish(),
  customs_info: z.any(),
  forms: z.array(FormSchema),
  is_from_alternative_account: z.boolean().nullish(),
  shipping_provider_type: z
    .enum(ShippingProviderType)
    .default(ShippingProviderType.EASYPOST),
  rates: z.array(RateSchema),
  selected_rate: RateSchema,
  postage_label: LabelSchema.nullish(),
  insurance: z.string().nullish() as unknown as z.ZodString,
  tracking_code: z.string(),
  tracker: z.any(), // as z.ZodType<ExternalShipmentTracker>,
  created_at: z.string(),
  updated_at: z.string(),
});
export const ShipmentSchema: z.ZodType<Shipment> = ShipmentSchema_;
export interface Shipment extends z.infer<typeof ShipmentSchema_> {}

export interface FulfillmentTracker {
  _tracker: ExternalShipmentTracker;
  fulfillmentID: string;
  locationId?: string;
}

export interface TrackingDetail {
  datetime: string;
  message: string;
  tracking_location: {
    city: string;
    state: string;
    country: string;
    zip: string;
  };
}
